import { useContext } from 'react';

import Context from './context';

export const useRightToLeft = () => useContext(Context);
